import React, { useEffect, useState } from "react";
import { getAboutMe } from "../../Services/service";

function SidebarAbout() {
  const [aboutinfo , setAboutinfo]=useState()
  useEffect(() => {
    loadData();
  },[]);
  async function loadData() {
    const fd=await getAboutMe();
    setAboutinfo(fd);
  }
  // console.log(aboutinfo)
  return (
    <>
    {aboutinfo && aboutinfo.aboutmeinfo.map((item)=>{
      return(
    <div className="binduz-er-sidebar-about">
      <div className="binduz-er-sidebar-title">
        <h4 className="binduz-er-title">{item.title}</h4>
      </div>
      <div className="binduz-er-sidebar-about-item">
        <div className="binduz-er-sidebar-about-user d-flex">
          <div className="binduz-er-thumb">
            <img src={require(`../../assets/images/user.jpg`).default} alt="" />
          </div>
          <div className="binduz-er-content">
            <h4 className="binduz-er-title">{item.author}</h4>
            <span>{item.author1}</span>
            <ul>
              <li>
                <a href="#">
                  <i className="fab fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fab fa-twitter"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fab fa-behance"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fab fa-youtube"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fab fa-linkedin"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="binduz-er-text">
          <p style={{fontSize:"15px",fontWeight:"600"}}>
            {item.p1}
          </p>
          <a className="binduz-er-main-btn" href="#">
            {item.connect}
          </a>
        </div>
      </div>
    </div>
  )})}
    </>
    );
}

export default SidebarAbout;
